module.exports = __webpack_public_path__ + "media/dianlixunxian.ff114386.mp4";